



function Footer() {
 


  return (
    <div  >
      <footer class="text-center text-start bg-dark text-light">
       

        <section class=" my-3 py-3">
          <div class="container text-center text-md-start mt-5">
            <div class="row mt-3">
              <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                <h6 class="text-uppercase fw-bold mb-4">
                  <i class="fas fa-gem me-3 text-secondary"></i>Ravendra Patel
                </h6>
                <p></p>
              </div>

              

              <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <h6 class="text-uppercase fw-bold mb-4">Contact</h6>
                <p>
                  <i class="fas fa-home me-3 text-secondary"></i>{" "}
                  Bhopal,M.P.,India
                </p>
                <p>
                  <i class="fas fa-envelope me-3 text-secondary"></i>
                  Email Id: Rp7098979@gmail.com
                </p>
                <p>
                  <i class="fas fa-phone me-3 text-secondary"></i> + 91
                  7898244625
                </p>
              </div>
            </div>
          </div>
        </section>

        <div class="text-center p-3">© 2021 Copyright: Ravendra Patel</div>
      </footer>
    </div>
  );
}
export default Footer;
